import React, { useRef } from 'react'
import { Modal } from 'react-bootstrap';
import { useEffect, useState } from "react";
import blockIcon from "../../../../../assets/img/block-icon.svg";
import returnIcon from "../../../../../assets/img/modals/return.svg";
import CroppieModal from '../../../../croppie-modal';
import { ReactSortable } from 'react-sortablejs';
import removeicon from "../../../../../assets/img/products/removeicon.svg";
import { hideLoader, showLoader } from '../../../../loader';
import ErrorMessage from '../../../../errors/errorMessage';
import leftAlignIcon from "../../../../../assets/img/modals/left-align-icon.svg";
import rightAlignIcon from "../../../../../assets/img/modals/right-align-icon.svg";
import AddVariableDropdown from './add-variable-dropdown';
import FontDropdown from './font-dropdown';
import CropperModal from '../../../../cropper-modal';
import { toast } from 'react-toastify';
const MAXIMUM_WIDTH = 300;
const MINIMUM_WIDTH = 50;
function GlobalblockPage({ type, error, setError, showSectionChildModal, setShowSectionChildModal, handleSubmit, handleUpdate, data, close }) {

    const [title, setTitle] = useState();
    const [description, setDescription] = useState();
    const [cover_image, setCoverImage] = useState();
    const [croppie, setCroppie] = useState(null);
    const [croppie_image, setcroppie_image] = useState({ url: "", id: null });
    const [showCroppieModal, setshowCroppieModal] = useState(null);
    const [coverImageURl, setCoverImageURl] = useState(null);
    const [videoUrl, setVideoUrl] = useState(null);
    const [features, setFeatures] = useState([""]);
    const [alignment, setAlignment] = useState("left");
    const [lastFocusedInput, setLastFocusedInput] = useState(null);
    const [lastFocusedIndex, setLastFocusedIndex] = useState(null);
    const [otherData, setOtherData] = useState({});
    const [selectedSize, setSelectedSize] = useState({
    'title_size': type == 'large_text' ? 5 :4,
    'description_size': 2,
    });
    const cropperRef = useRef(null);
    // console.log("features",features)
    const handleopenmodal = (e) => {
        setcroppie_image({ url: "", id: null, name: null, type: null });
        generate_image_preview(e.target);
        hideLoader();
    };
    const handleHideModal = () => {
        setshowCroppieModal(false);
        setCroppie(null);
        setcroppie_image({ url: "", id: null });
        // history.push(basePath + "/products");
      };
      const croppieClose = () => {
        showLoader();
        setshowCroppieModal(false);
        setCroppie(null);
        setTimeout(() => {
          hideLoader();
        }, 400);
      };
      const croppedImage = () => {
        if (croppie !== null) {
          const cropper = cropperRef.current.cropper;
          cropper.getCroppedCanvas().toBlob((blob) => {
              // Do something with the Blob, like setting it to state
              setCoverImage({ cover_image: blob });
              
              // Optionally create a URL for preview purposes
              const croppedBlobUrl = URL.createObjectURL(blob);
              setCoverImageURl(croppedBlobUrl);
              
              // Close the croppie/modal
              croppieClose();
          }, 'image/png', 1);
          return;
          croppie
            .result({
              type: "canvas",
              size: "original",
              format: "png",
              quality: 1,
            })
            .then((response) => {
              const tempObj = { image_url: response };
              croppie
                .result({
                  size: "viewport",
                  format: "png",
                  quality: 1,
                  type: "blob",
                })
                .then((res) => {
                  setCoverImage(
                    {
                      cover_image:res
                    }
                  )
                  setCoverImageURl(croppie?.data?.url)
                  croppieClose()
                });
            });
        }
      };
      function Removecardfun() {
        setCoverImage(null)
        setCoverImageURl(null)
      }
      function generate_image_preview(input) {
        showLoader();
        if (input.files && input.files[0]) {
          let reader = new FileReader();
          if (input.files[0].size >= 5242880) {
            $("#image_file_input").val("");
            let notification_container = $(".notification-container");
            toast.error("File Size Should not exceed 5MBs");
            // showModal();
            return;
          }
          let val = input.files[0].name;
          let valid_extensions = ["png", "jpg", "jpeg"];
          let extension =
            val.substring(val.lastIndexOf(".") + 1, val.length) || val;
          if (!valid_extensions.includes(extension)) {
            $("#image_file_input").val("");
            let notification_container = $(".notification-container");
            toast.error("Invalid Image File. Should be png, jpg or jpeg");
            // showModal();
            return;
          }
          // reader.onload = (event) => {
          //   setcroppie_image({
          //     ...croppie_image,
          //     url: event.target.result,
          //   });
          //   setshowCroppieModal(true);
          //   setTimeout(() => {
          //     const el = document.getElementById("image_demo2");
          //     try {
          //       if (el) {
          //         var croppieInstance = new Croppie(el, {
          //           enableExif: true,
          //           viewport: {
          //             width: 850,
          //             height: 470,
          //             type: "square",
          //           },
          //           boundary: {
          //             width: 870,
          //             height: 570,
          //           },
          //         });
          //         croppieInstance
          //           .bind({
          //             url: event.target.result,
          //           })
          //           .then(function () {
          //             setTimeout(() => { }, 300);
          //           })
          //           .catch(() => {
          //             croppieClose();
          //           });
          //         setCroppie(croppieInstance);
          //       }
          //     } catch { }
          //   }, 500);
          // };
          // reader.readAsDataURL(input.files[0]);
          const files = event.target.files;
          reader.onload = () => {
            setshowCroppieModal(true);
            setCroppie(reader.result);
          };
          reader.readAsDataURL(files[0]);
        }
      }
      const handleFormAction = (actionType, e) => {
        let formData;
        if (type === "horizontal" || type === 'vertical') {
            formData = { title, description, cover_image: cover_image?.cover_image , alignment };
        } else if (type === 'hero') {
            formData = { title, description, videoUrl };
        } else if (type === 'pricing') {
            formData = { title, features: features.filter(feature => feature.trim() !== '') };
            if (!formData.features || formData.features.length === 0) {
                setError(["Feature is required"]);
                return false;
            } else if (!formData.title) {
                setError(["Title is required"]);
                return false;
            }
        } else if (type === 'footer' || type === 'large_text') {
            formData = { title };
        }
        formData = { ...formData, title_size: selectedSize?.title_size };
        if (formData?.description) {
          formData = { ...formData, description_size: selectedSize?.description_size  };
        }
        if (otherData) {
            formData = {...formData, ...otherData };
        }
        if (actionType === 'save') {
            handleSubmit(formData, type);
        } else if (actionType === 'update') {
            handleUpdate(formData, type, e.target.dataset?.value);
        }
    };
    //   const handleSave = () => {
    //     let formData;
    //     if (type == "horizontal" || type == 'vertical') {
    //       formData = {title, description, cover_image:cover_image?.cover_image};
    //     }else if (type == 'hero'){
    //       formData = {title, description, videoUrl};
    //     }else if (type == 'pricing'){
    //        formData = {title, features:features.filter(feature => feature.trim() !== '')};
    //        if (!formData.features || formData.features.length === 0) {
    //         setError(["Feature is required"])
    //         return false;
    //        }else if(!formData.title){
    //         setError(["Title is required"])
    //         return false;
    //        }
    //     }else if (type == 'footer' || type == 'large_text'){
    //       formData = {title};
    //     }
    //     handleSubmit(formData,type);
    //   }
    //   const handleUpdateData = (e) => {
    //       let formData;
    //       if (type == "horizontal" || type == 'vertical') {
    //         formData = {title, description, cover_image:cover_image?.cover_image};
    //     }else if (type == 'hero'){
    //       formData = {title, description, videoUrl};
    //     }else if (type == 'pricing'){
    //         formData = {title, features:features.filter(feature => feature.trim() !== '')};
    //         if (!formData.features || formData.features.length === 0) {
    //         setError(["Feature is required"])
    //         return false;
    //         }else if(!formData.title){
    //         setError(["Title is required"])
    //         return false;
    //         }
    //     }else if (type == 'footer' || type == 'large_text'){
    //       formData = {title};
    //     }
    //     handleUpdate(formData,type,e.target.dataset?.value);
    // };
    const handleAlignmentChange = (e) => {
      setAlignment(e.target.value);
    };
    useEffect(()=>{
      if (data?.meta) { 
        const parsedMeta = JSON?.parse(data?.meta);
        setTitle(parsedMeta?.title);
        if (type == 'pricing') {
          setFeatures(parsedMeta?.features);
          setOtherData({button_text:parsedMeta?.button_text,button_url:parsedMeta?.button_url})
        }else{
          setVideoUrl(parsedMeta?.videoUrl);
          setAlignment(parsedMeta?.alignment ?? 'left');
          setDescription(parsedMeta?.description);
          setCoverImage({ cover_image: parsedMeta?.cover_image });
          setCoverImageURl(parsedMeta?.cover_image);
        }
        setSelectedSize({
            'title_size': parsedMeta?.title_size || (type === 'large_text' ? 5 : 4),
            'description_size': parsedMeta?.description_size || 2,
        });
      }
  },[data?.meta])
  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index] = value;
    setFeatures(updatedFeatures);
  };
  function addFeature() {
    setFeatures([...features, ""]);
  }
  const removeFeature = (i) => {
    const newarr = [...features];
    newarr.splice(i, 1);
    setFeatures(newarr);
  }
  const addedVariable = (value,variable) => {
    // if (variable == 'title') {
    //   setTitle(title ? `${title} ${value}` : value);
    // }else {
    //   setDescription(`${description} ${value}`)
    // }
    if (variable === 'feature') {
      // If last focused was a feature textarea, find its index
      const featureIndex = parseInt(lastFocusedIndex);
      handleFeatureChange(featureIndex, features[featureIndex] ? `${features[featureIndex]} ${value}` : value);
    }else {
      const setFunctions = {
        title: setTitle,
        videoUrl: setVideoUrl,
        description: setDescription
      };
      
      const setFunction = setFunctions[variable];
      if (variable === 'videoUrl') {
        setFunction(prevValue => prevValue+value); // Directly set the value without space
      } else {
        setFunction(prevValue => prevValue ? `${prevValue} ${value}` : value);
      }
    }
  }
  function autoResize(textarea) {
    if (textarea.value.length > 80) {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
    }
}
  const handleChange = (e) => {
    setOtherData({...otherData,[e.target.name]:e.target.value});
  }
    return (
        <Modal centered show={showSectionChildModal} onHide={close}>
            <div className="modal-dialog-centered" role="document">
                <div className="modal-content">
                <div class="modal-header">
                      <span className='block-modal-headings'>
                      Edit
                      {type === 'horizontal' ?
                          ' Horizontal '
                        :
                        type === 'vertical' ?
                          ' Vertical '
                        :
                        type === 'hero' ?
                          ' Hero '
                        :
                        type === 'large_text' ?
                          ' Large Text '
                        :
                        type === 'footer' ?
                          ' Footer '
                        :
                          ' Pricing '
                      }
                      Section
                      </span>
                      <button type="button" class="close" onClick={close} aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                    <div className="modal-body">
                        <form name="product_type" method="post" role="form">
                            <div className="notification-container"></div>
                            {/* <div className="form-group">
                                <img src={blockIcon} width="40px" alt="" />
                                
                                    <h4 className="productHead1 mt-15px">
                                    {type === 'horizontal' ?
                                        'Edit Horizontal Section'
                                      :
                                      type === 'vertical' ?
                                        'Edit Vertical Section'
                                      :
                                      type === 'hero' ?
                                        'Edit Hero Section'
                                      :
                                      type === 'large_text' ?
                                        'Edit Large Text Section'
                                      :
                                      type === 'footer' ?
                                        'Edit Footer Section'
                                      :
                                        'Edit Pricing Section'
                                    }
                                    </h4>

                            </div> */}
                                  <ErrorMessage error={error} />
                            <div className="form-group mt-20px">
                              <div className='label-variable'>
                                {type === 'pricing' ?
                                     <label className="productlabels">
                                        Pricing Section Title
                                    </label>
                                    :
                                    <label className="productlabels">
                                        Headline
                                    </label>
                                }
                                <div className='d-flex gap-1 align-items-center'>
                                  <FontDropdown selectedSize={selectedSize} setSelectedSize={setSelectedSize} fontKey="title_size" />
                                  <AddVariableDropdown addedVariable={addedVariable} stateVariable={'title'}/>
                                </div>
                                </div>
                                 {
                                  type == 'hero' ?
                                <>
                                {/* <div className='heading-input d-flex p-0 justify-content-between align-items-baseline zaapGlobal-input mt-10px'>
                                  <div className='heading-input-main d-flex w-100 '> */}
                                  {/* <input
                                      type="text"
                                      className="width-dynamic zaapGlobal-input"
                                      name="headline"
                                      placeholder={"Add a feature or benefit"}
                                      value={title}
                                      onChange={(e) => setTitle(e.target.value)}
                                  /> */}
                                  <textarea
                                      type="text"
                                      value={title}
                                      className="zaapGlobal-input hidden-scroll"
                                      name="headline"
                                      placeholder={"Add a feature or benefit"}
                                      onInput={(e) => autoResize(e.target)}
                                      style={{minHeight: "30px"}}
                                      onChange={(e) => setTitle(e.target.value)}
                                  >
                                  </textarea>
                                  {/* </div>
                                </div> */}
                                </>
                                :
                                <>
                                {/* <div className='heading-input d-flex p-0 justify-content-between align-items-baseline zaapGlobal-input mt-10px'>
                                  <div className='heading-input-main d-flex w-100 '> */}
                                  {/* <input
                                      type="text"
                                      className="zaapGlobal-input"
                                      name="headline"
                                      placeholder={type === 'pricing' ? "Title" : "Add a feature or benefit"}
                                      value={title}
                                      onChange={(e) => setTitle(e.target.value)}
                                  /> */}
                                  <textarea
                                      type="text"
                                      className="zaapGlobal-input hidden-scroll"
                                      name="headline"
                                      value={title}
                                      placeholder={type === 'pricing' ? "Title" : "Add a feature or benefit"}
                                      onInput={(e) => autoResize(e.target)}
                                      style={{minHeight: "30px"}}
                                      onChange={(e) => setTitle(e.target.value)}
                                  >
                                  </textarea>
                                  {/* </div>
                                    <AddVariableDropdown addedVariable={addedVariable} stateVariable={'title'}/>
                                  </div> */}
                                  </>
                                  }

                            </div>
                            {
                              type !== 'footer' && type != 'large_text' &&
                              <>
                            <div className="form-group mt-20px">
                                  <div className='label-variable '>
                                     <label className="productlabels ">
                                      {type === 'pricing' ? 'Feature' : type === 'hero' ? 'Subheading':'Description'}
                                    </label>
                                      <div className='d-flex gap-1 align-items-center'>
                                      {
                                        type !== 'pricing' &&
                                        <FontDropdown selectedSize={selectedSize} setSelectedSize={setSelectedSize} fontKey="description_size" />
                                      }
                                      <AddVariableDropdown addedVariable={addedVariable} stateVariable={type === 'pricing' ? 'feature' : 'description'}/>
                                      </div>
                                    </div>
                                
                                {
                                  type === 'pricing'
                                    ? features?.map((feature, i) => (
                                        <div style={{minHeight: "30px"}} className="ps-0 pb-0 pt-0 form-group zaapGlobal-input mt-10px d-flex align-items-center " key={i}>
                                          {/* <input
                                            type="text"
                                            className="color-5b5b5b"
                                            name="headline"
                                            placeholder={"Add feature"}
                                            value={feature}
                                            onChange={(e) => handleFeatureChange(i, e.target.value)}
                                          /> */}
                                            <textarea
                                              type="text"
                                              value={feature}
                                              className="color-5b5b5b zaapGlobal-input hidden-scroll"
                                              name="headline"
                                              placeholder={"Add feature"}
                                              onInput={(e) => autoResize(e.target)}
                                              style={{minHeight: "30px"}}
                                              onChange={(e) => handleFeatureChange(i, e.target.value)}
                                              onFocus={() => {
                                                setLastFocusedInput('feature');
                                                setLastFocusedIndex(i);  // Also track which feature was focused
                                              }}
                                          >
                                          </textarea>
                                          {features.length > 1 ? 
                                            <img src={removeicon} width={"13px"} style={{marginLeft:'10px'}} onClick={(a) => removeFeature(i)}/>
                                         : <></>}
                                        </div>
                                      ))
                                    : type === 'hero' ? (
                                        <>
                                        {/* <div className='d-flex p-0 justify-content-between align-items-baseline zaapGlobal-input mt-10px'> */}
                                          {/* <input
                                            type="text"
                                            className="zaapGlobal-input"
                                            name="headline"
                                            placeholder={"Add more details"}
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                          /> */}
                                          <textarea
                                              type="text"
                                              value={description}
                                              className="zaapGlobal-input hidden-scroll"
                                              name="headline"
                                              placeholder={"Add more details"}
                                              onInput={(e) => autoResize(e.target)}
                                              style={{minHeight: "30px"}}
                                              onChange={(e) => setDescription(e.target.value)}
                                          >
                                          </textarea>
                                          {/* </div> */}
                                        </>
                                      )
                                      : (
                                        <>
                                        {/* <input
                                        type="text"
                                        className="zaapGlobal-input mt-10px"
                                        name="headline"
                                        placeholder={"Add more details"}
                                        value={description}
                                        maxLength={250}
                                        onChange={(e) => setDescription(e.target.value)}
                                      /> */}
                                      <textarea
                                          type="text"
                                          value={description}
                                          className="zaapGlobal-input hidden-scroll mt-10px"
                                          name="headline"
                                          placeholder={"Add more details"}
                                          onInput={(e) => autoResize(e.target)}
                                          style={{minHeight: "30px"}}
                                          onChange={(e) => setDescription(e.target.value)}
                                      >
                                      </textarea>
                                      <span className='fs-12 text-end d-block w-100 mt-1'>{description?.length}/250</span>
                                      {description?.length > 250 && (
                                        <span className="fs-12 text-danger d-block mt-1 ms-1">
                                            We recommend keeping your text under 250 characters for a more aesthetic design.
                                        </span>
                                      )}
                                      </>
                                      )
                                    }
                            </div>
                            <div className="form-group mt-20px">
                              {type === 'pricing' || type  !== 'hero' ?
                              <>
                                {type === 'pricing' ?
                                     <span></span>
                                    :
                                    <label className="productlabels">
                                        Section Image
                                    </label>
                                }
                                {
                                  type === 'pricing' ?
                                  <>
                                    <button type="button" className="newGraybtn position-relative" onClick={addFeature}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                        </svg>Add feature
                                    </button> 
                                    <div className="form-group mt-20px">
                                        <label className="productlabels mb-1">
                                            CTA Button
                                        </label>
                                        <input
                                            type="text"
                                            className="zaapGlobal-input"
                                            name="button_text"
                                            placeholder="Button Text"
                                            onChange={handleChange}
                                            value={otherData?.button_text}
                                        />
                                        <input
                                            type="url"
                                            className="zaapGlobal-input mt-2"
                                            name="button_url"
                                            placeholder="https://example.com"
                                            onChange={handleChange}
                                            value={otherData?.button_url}

                                        />
                                    </div>
                                  </>
                                  :
                                <>
                                {!coverImageURl?
                                <button type="button" className="newGraybtn position-relative ">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                        </svg>Upload New
                                        <input
                                            type="file"
                                            className="dropzone dropzone4 inset-0"
                                            name="cover_image"
                                            accept=".png,.jpg,.jpeg"
                                            id="image_file_input"
                                            onChange={(e)=>handleopenmodal(e)}
                                        />
                                </button>:null
                                }
                                <div className="preview-zone hidden "></div>
                                <div >
                                    {
                                    coverImageURl &&
                                    <div className='d-flex align-items-center mt-15px'>
                                        <div>
                                            <img className="prevImageU" src={coverImageURl} />
                                        </div>
                                        <div>
                                            <img onClick={(e) => Removecardfun()} src={removeicon} width={"22px"} style={{ padding: 4, cursor: "pointer" }} />
                                        </div>
                                    </div>
                                    }
                                </div>
                                </>
                                }
                                </>:
                                type == 'hero' ? 
                                <>
                                <label className="productlabels label-variable ">
                                        Video URL
                                      <AddVariableDropdown addedVariable={addedVariable} stateVariable={'videoUrl'}/>
                                  </label>
                                  <input
                                     type="url"
                                     className="zaapGlobal-input mt-10px"
                                     name="headline"
                                     placeholder={"youtube.com/..."}
                                     value={videoUrl}
                                     onChange={(e) => setVideoUrl(e.target.value)}
                                   />
                                </>:null
                              }
                            </div>
                            </>
                            }
                            { type == "horizontal" || type == "vertical" ?
                            
                            <div class="form-group">
                              <label><small>Text alignment</small></label>
                              <div class="up-in-toggle up-in-toggle-alignment bg-f1f1f1 w-25 btn-semi-rounded">
                                  <input type="radio" id="text_align_left" name="alignment" checked={alignment == "left" } value={"left"} onChange={handleAlignmentChange} />
                                  <label htmlFor="text_align_left" class="btn-semi-rounded">
                                      <img className={type == "vertical" ? 'rotated-alignment-icon': null} src={leftAlignIcon} alt="" />
                                  </label>
                                  <input type="radio" id="text_align_right" checked={alignment == "right"} name="alignment" value={"right"} onChange={handleAlignmentChange} />
                                  <label htmlFor="text_align_right" class="btn-semi-rounded">
                                      <img className={type == "vertical" ? 'rotated-alignment-icon': null} src={rightAlignIcon} alt="" />
                                  </label>
                              </div>
                        </div> : null
                            }
                            <div class="d-flex gap-2 mt-20px align-items-center justify-content-center">
                              <button type="button" onClick={close} class="fs-12 w-50 mt-0 integration-btns integration-btn-grey">
                                Cancel
                              </button>
                              <button data-value={data?.id} type="button" onClick={(e) => handleFormAction((data?.id ? 'update' : 'save'),e)} class="fs-12 w-50 shadow-none  project-blue-btn">
                                  Save Changes
                              </button>
                          </div>                       
                        </form>
                    </div>
                </div>
            </div>
            <CropperModal croppie={croppie} cropperRef={cropperRef} show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} />
        </Modal>
        
    )
}

export default GlobalblockPage